import AuthLayout from "../../../components/layouts/auth";
import { useState } from "react";
import MarketingCampaignForm from "./form";
import { Link, useParams } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { MarketingCampaignProps } from "../../../types/MarketingCampaignProps";
import { useSingleMarketingCampaign } from "../../../composables/marketing/useSingleMarketingCampaign";
import SpinnerLoader from "../../../components/loader/spinner-loader";
import MarketingStatusBadge from "./status-badge";

const SingleMarketing = () => {
  const { uuid } = useParams<{ uuid: string }>();
  const {
    data,
    isLoading,
  }: { data?: MarketingCampaignProps; isLoading: boolean } =
    useSingleMarketingCampaign({
      code: uuid || "",
      enabled: !!uuid,
    });

  if (isLoading) {
    return <div className="flex justify-center items-center h-screen"><SpinnerLoader/></div>;
  }

  if (!data) {
    return (
      <AuthLayout>
        <div>Marketing campaign not found.</div>
        <Link to={"/marketing"} className="pryBtn mt-5">
          Go back
        </Link>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout>
      <div>
        <Link to={"/marketing"} className="btn btn-primary"></Link>
        <h2 className="text-[#8D8D8D] font-[600] text-[14px]">
          Marketing Campaign / edit
        </h2>
        <div className="flex items-center pl-0 mt-4 mb-5 space-x-2">
          <span>
            <Link to={"/marketing"}>
              <ChevronLeft size={20} className="-ml-2" />
            </Link>
          </span>
          <h1 className="font-[600] text-tertiary text-[18px] space-x-2 flex items-center">
            <span>Marketing Campaign</span>
            <MarketingStatusBadge status={data.status} />
          </h1>
        </div>
        <MarketingCampaignForm marketingCampaign={data} />
      </div>
    </AuthLayout>
  );
};

export default SingleMarketing;
